// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var List        = require("bs-platform/lib/js/list.js");
var $$Array     = require("bs-platform/lib/js/array.js");
var Curry       = require("bs-platform/lib/js/curry.js");
var MaterialUI  = require("bs-material-ui/lib/js/src/MaterialUI.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./Select.css')));

function valueFromEvent(evt) {
  return evt.target.value;
}

var component = ReasonReact.statelessComponent("Select");

function make(label, data, value, onChange, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      var options = $$Array.of_list(List.map((function (x) {
                  return ReasonReact.element(/* None */0, /* None */0, MaterialUI.MenuItem[/* make */0](/* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* `String */[
                                    -976970511,
                                    x[/* value */0]
                                  ]], /* array */[x[/* label */1]]));
                }), data));
      return ReasonReact.element(/* None */0, /* None */0, MaterialUI.FormControl[/* make */0](/* None */0, /* Some */["Select-root"], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* array */[
                      ReasonReact.element(/* None */0, /* None */0, MaterialUI.InputLabel[/* make */0](/* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[{
                                  focused: "Select-focused"
                                }], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* array */[label])),
                      ReasonReact.element(/* None */0, /* None */0, MaterialUI.Select[/* make */0](/* None */0, /* None */0, /* Some */["Select-inputwrapper"], /* None */0, /* Some */[ReasonReact.element(/* None */0, /* None */0, MaterialUI.Input[/* make */0](/* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* array */[]))], /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* `String */[
                                  -976970511,
                                  value
                                ]], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[(function (e) {
                                    return Curry._1(onChange, e.target.value);
                                  })], /* None */0, /* None */0, /* array */[options]))
                    ]));
    });
  return newrecord;
}

exports.valueFromEvent = valueFromEvent;
exports.component      = component;
exports.make           = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/components/Select.re
// module id = 428
// module chunks = 0